export default [
  {
    name: 'Кирпичный',
    key: 'brick',
  },
  {
    name: 'Монолитный',
    key: 'monolith',
  },
  {
    name: 'Панельный',
    key: 'panel',
  },
  {
    name: 'Блочный',
    key: 'block',
  },
  {
    name: 'Деревянный',
    key: 'wood',
  },
  {
    name: 'Сталинский',
    key: 'stalin',
  },
  {
    name: 'Щитовой',
    key: 'boards',
  },
  {
    name: 'Монолитно-кирпичный',
    key: 'monolithBrick',
  },
  {
    name: 'Старый фонд',
    key: 'old',
  },
  {
    name: 'Каркасный',
    key: 'wireframe',
  },
  {
    name: 'Газобетонный блок',
    key: 'aerocreteBlock',
  },
  {
    name: 'Газосиликатный блок',
    key: 'gasSilicateBlock',
  },
  {
    name: 'Пенобетонный блок',
    key: 'foamConcreteBlock',
  },
];
